import React, {useState} from "react"
import Styled from "styled-components"

const FilterIcon = Styled.img`
	position: absolute;
	width: 20px;
	right: 20px;
	&:hover {
		cursor: pointer;
	}
`
const FilterContainer = Styled.div`
	position: absolute;
	top: 30px;
	right: 27px;
	background: white;
	z-index: 999;
	text-align: left;
	box-shadow: 1px 1px 5px #cacaca;
	padding: 10px;
	&:hover {
		cursor: pointer;
	}
`

const CheckIcon = Styled.img`
	width: 10px;
	margin-right: 10px;
	opacity: ${props => props.active ? '1' : '0'};
`

// This is a custom filter UI for selecting
// a unique option from a list
const SelectColumnFilter = ({column: {filterValue, setFilter, preFilteredRows, id}}) => {

	const [showFilters, setShowFilters] = useState(false)

	const options = ["Active", "Inactive"]

	const handleFilter = value => {
		setFilter(value || undefined)
		setShowFilters(false)
	}

	return (
		<>
			<FilterIcon
				src={"/assets/images/icons/svg/filter.svg"}
				alt='filter'
				onClick={() => setShowFilters(!showFilters)}
			/>
			{showFilters && (
				<FilterContainer>
					<div onClick={() => handleFilter("")}>
						<CheckIcon
							src={"/assets/images/icons/svg/check.svg"}
							alt='check'
							active={filterValue === undefined}
						/>
						All
					</div>
					{options.map(option => (
						<div onClick={() => handleFilter(option)}>
							<CheckIcon
								src={"/assets/images/icons/svg/check.svg"}
								alt='check'
								active={filterValue === option}
							/>
							{option}
						</div>
					))}
				</FilterContainer>
			)}
		</>
	)
}

export default SelectColumnFilter
